import React, { useEffect, useState } from 'react';

import { Typography } from 'antd';
import useMember from 'hooks/useMember';
import { GET } from 'utils';
import { api } from 'utils/apiRoutes';
const { Title } = Typography;
const HomeBanner = () => {
  const [user, setUser] = useState();
  const [profile, setProfile] = useState(null);
  const { getUserPrefence } = useMember();

  useEffect(() => {
    getUserPrefence().then((res) => {
      setUser(res);
    });
    GET(api.getProfile).then((res) => {
      setProfile(res?.data);
    })

  }, []);
  return (
    <div style={{ position: 'relative' }}>
      <img
        style={{
          height: 300,
          width: '100%',
          objectFit: 'cover',

        }}
        src={
          (user as any)?.cover_photo
            ? (user as any)?.cover_photo
            : '/assets/header_1.svg'
        }
        alt="back"
      />
      <Title level={2} style={{ position: 'absolute', fontSize: 24, color: '#000', textAlign: 'center', zIndex: 500, top: '15%', left: '50%', translate: '-50% -50%' }}>
        Welcome, {profile && profile.first_name}{' '} {profile && profile.last_name}!<img style={{ marginLeft: '16px' }} src={'/assets/Celebration.png'} alt={'icon'} />
      </Title>
    </div>
  );
};

export default HomeBanner;
